import * as AccordionPrimitive from '@radix-ui/react-accordion';
import React, { type ReactNode } from 'react';
import { ChevronDown } from '@/components/Icons/ChevronDown';
import { NotificationChannel } from '@/types/notifications';
import { tv } from '@/utils/tv';

const subtitleStyle = tv({
  base: 'text-body-14',
  variants: {
    attention: {
      true: 'text-accent',
      false: 'text-subtle-foreground',
    },
  },
});

interface Props {
  channel: NotificationChannel;
  icon: ReactNode;
  title: string;
  subtitle?: string;
  isSubtitleAttention?: boolean;
  children: ReactNode;
}

export const NotificationCard: React.FC<Props> = ({
  channel,
  icon,
  title,
  subtitle,
  isSubtitleAttention = false,
  children,
}) => (
  <AccordionPrimitive.Item
    value={channel}
    className="overflow-hidden rounded-2xl bg-card shadow-card"
  >
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger className="group flex w-full cursor-pointer items-center gap-3 py-4 pr-3 pl-4 text-left outline-none data-[state=open]:border-b data-[state=open]:border-border">
        {icon}
        <div className="flex min-w-0 flex-1 flex-col">
          <p className="text-callout-16 text-foreground">{title}</p>
          {subtitle && (
            <p className={subtitleStyle({ attention: isSubtitleAttention })}>
              {subtitle}
            </p>
          )}
        </div>
        <ChevronDown className="size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-data-[state=open]:rotate-180" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
    <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
      <div className="flex flex-col gap-3 pt-3">{children}</div>
    </AccordionPrimitive.Content>
  </AccordionPrimitive.Item>
);
